import { gql } from '../../../__generated__';

export const LOGIN = gql(`
  mutation LoginWeb($data: LoginWebInputData!) {
    loginWeb(data: $data) {
      message
      accessToken
      refreshToken
      data {
        firstName
        lastName
        email
        phoneNo
        isRegistered
        countryCode
        avatar
      }
    }
  }
`);

export const REFRESH_TOKEN = gql(`
  mutation RefreshTokenWeb($data: RefreshTokenWebInput) {
    refreshTokenWeb(data: $data) {
      accessToken
    }
  }
`);

export const UPDATE_USER = gql(`
  mutation updateUser($data: UpdateUserWebInput) {
    updateUserWeb(data: $data) {
      data {
        firstName
        lastName
        phoneNo
        email
        avatar
        countryCode
        isRegistered
      }
        message
    }
  }
`);
